import { useEffect } from "react";

const LOGO = "/logo.png";

export const BRAND_LOGO = LOGO;

export default function SEO({ title, description, image, type = "website", schema }) {
  useEffect(() => {
    document.title = title ? `${title}` : "Happy Holidays Wale | Premium Tour Packages";
    const setMeta = (attr, key, val) => {
      if (!val) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", val);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    const absImage = image && image.startsWith("/") ? window.location.origin + image : image;
    setMeta("property", "og:image", absImage);
    setMeta("name", "twitter:card", "summary_large_image");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = window.location.href;

    let script = document.getElementById("ld-json");
    if (script) script.remove();
    if (schema) {
      script = document.createElement("script");
      script.id = "ld-json";
      script.type = "application/ld+json";
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }, [title, description, image, type, schema]);
  return null;
}
